import { render, staticRenderFns } from "./FloatingWhatsAppPopup.vue?vue&type=template&id=a557d5b4&"
import script from "./FloatingWhatsAppPopup.vue?vue&type=script&lang=js&"
export * from "./FloatingWhatsAppPopup.vue?vue&type=script&lang=js&"
import style0 from "./FloatingWhatsAppPopup.vue?vue&type=style&index=0&id=a557d5b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports